// components/ChristmasScene.js
import React, { useState, useEffect } from 'react';
import ChristmasTree from './ChristmasTree';
import Snowfall from './Snowfall';
import Card from './Card';
import LoveNotes from './LoveNotes';

const ChristmasScene = () => {
  const [showCard, setShowCard] = useState(false);
  const [showContent, setShowContent] = useState(false);
  const [showSnow, setShowSnow] = useState(false);
  const [showNotes, setShowNotes] = useState(false);

  useEffect(() => {
    // Set initial background to transparent
    document.body.style.transition = 'background-color 1s ease';
    document.body.style.backgroundColor = 'transparent';
    
    // Animation timers
    setTimeout(() => setShowContent(true), 100);
    setTimeout(() => setShowSnow(true), 500);
    
    // Set background color and show card after animation
    setTimeout(() => {
      document.body.style.backgroundColor = '#60A5FA'; // bg-blue-400
      setShowCard(true);
    }, 4000);
    
    setTimeout(() => setShowNotes(true), 8000);

    // Cleanup function to reset body background when component unmounts
    return () => {
      document.body.style.backgroundColor = '';
      document.body.style.transition = '';
    };
  }, []);

  return (
    <div className="min-h-screen w-full overflow-x-hidden">
      <div className={`fixed inset-0 transition-opacity duration-1000
        ${showContent ? 'opacity-100' : 'opacity-0'}`}>
        
        <div className="absolute inset-0">
          <Snowfall show={showSnow} />
        </div>

        {/* Christmas Trees */}
        <div className="absolute bottom-0 w-full flex justify-around z-10">
          <div className={`relative transform transition-all duration-1500 ease-out delay-500 w-full flex justify-center
            ${showContent ? 'translate-y-0 opacity-100' : 'translate-y-full opacity-0'}`}>
            <ChristmasTree variant="dark" />
          </div>
          <div className={`relative transform transition-all duration-1500 ease-out delay-700 w-full flex justify-center
            ${showContent ? 'translate-y-0 opacity-100' : 'translate-y-full opacity-0'}`}>
            <ChristmasTree variant="light" />
          </div>
        </div>
      </div>

      <Card show={showCard} />
      <LoveNotes show={showNotes} />
    </div>
  );
};

export default ChristmasScene;